import { LayoutModule } from '@angular/cdk/layout';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageWithLoaderComponent } from '../components/image-with-loader/image-with-loader.component';
import { FilmSelector, Films } from 'www-cms';
import { BaseBuildingBlockComponent } from '../components/base-building-block.component';
import { BuildingBlockOutletComponent } from '../../shared/components/building-block-outlet/building-block-outlet.component';
import { LastItemBgClass } from '../../shell/shell.service';
import { DirectusDirective } from 'directus';

@Component({
  selector: 'ss-www-film-selector',
  imports: [
    CommonModule,
    BuildingBlockOutletComponent,
    LayoutModule,
    ImageWithLoaderComponent,
    DirectusDirective,
  ],
  templateUrl: './film-selector.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilmSelectorComponent extends BaseBuildingBlockComponent {
  @Input({ required: true }) filmSelectorData!: FilmSelector;
  @Output() activeIndex = new EventEmitter<number>();
  override lastBlock: boolean = false;
  currentIndex = 0;
  trackFilm(index: number, item: Films) {
    return item.id;
  }

  setFilm(index: number) {
    this.currentIndex = index;
  }
  setActiveIndex(index: number) {
    this.currentIndex = index;
    this.emitActiveIndex(index);
  }

  override getBgClass(): LastItemBgClass {
    return 'bg-ss-www-background';
  }

  private emitActiveIndex(index: number) {
    this.activeIndex.emit(index);
  }
}
